export default __webpack_public_path__ + "images/card-logo-discover.1bac2de613f0824bc12cd06e1b9c019f.png";